// extracted by mini-css-extract-plugin
module.exports = {"container":"Tab_container__1Hk3c"};